import {
  Button,
  Icon,
  Text,
  Popover,
  LegacyCard,
  HorizontalStack,
  VerticalStack,
  Box,
  InlineError,
  Link,
} from '@shopify/polaris';
import { DeleteMinor, NotificationMajor } from '@shopify/polaris-icons';
import { useCallback, useContext, useState } from 'react';
import UserContext from '../../../context/UserContext';
import { dateToTimeSince } from '../../../helpers/dateConverter';

export const PopoverNotifications = () => {
  const [isOpen, setIsOpen] = useState(false);
  const togglePopover = useCallback(() => setIsOpen((open) => !open), []);

  const [state, dispatch] = useContext(UserContext);
  const { files } = state;

  const handleDeleteFiles = useCallback(() => {
    dispatch({ type: 'DELETE_FILES' });
    togglePopover();
  }, [dispatch, togglePopover]);

  const hasFiles = files.length > 0;

  return (
    <Popover
      active={isOpen}
      activator={
        <Button onClick={togglePopover} icon={NotificationMajor} accessibilityLabel="Descargas" />
      }
      onClose={togglePopover}
    >
      <Popover.Pane fixed>
        <LegacyCard
          title="Descargas"
          actions={hasFiles ? [{ content: <Icon source={DeleteMinor} />, onAction: handleDeleteFiles }] : undefined}
        >
          {!hasFiles ? (
            <LegacyCard.Section>
              <Box padding="2">
                <Text variant="bodyMd" color="subdued" alignment="center">
                  No hay descargas
                </Text>
              </Box>
            </LegacyCard.Section>
          ) : (
            files.map((f) => (
              <LegacyCard.Section key={f.id}>
                <HorizontalStack align="space-between" blockAlign="center" gap="4" wrap={false}>
                  <VerticalStack gap="05">
                    {!f.loading && !f.error ? (
                      <Link plain monochrome textAlign="left" url={f.url} target="_blank" external>
                        <Text variant="bodyMd" as="span">
                          {f.name}
                        </Text>
                      </Link>
                    ) : (
                      <Text variant="bodyMd" as="span">
                        {f.name}
                      </Text>
                    )}
                    <Text variant="bodySm" color="subdued" as="span">
                      {f.type}
                    </Text>
                  </VerticalStack>
                  <Box minWidth="80px">
                    <Text variant="bodySm" color="subdued" as="span" alignment="end">
                      {f.loading && 'Descargando...'}
                      {!f.loading && !f.error && dateToTimeSince(f.date)}
                    </Text>
                    {f.error && <InlineError message="Error en la descarga" fieldID={f.id} />}
                  </Box>
                </HorizontalStack>
              </LegacyCard.Section>
            ))
          )}
        </LegacyCard>
      </Popover.Pane>
    </Popover>
  );
};
